import StreamHealthCheckModal from "./container";

export default StreamHealthCheckModal;